import { INGXLoggerConfig, INGXLoggerMetadata, NGXLoggerWriterService } from "ngx-logger";
import { CrossAppMessagingService } from "../_services/crossApp-messaging.service";
import { IMessage } from "../_interface/crossAppMessaging";
import { environment } from "src/environments/environment";
import { writeToConsole } from "./writeToConsole";
import { safeStringify } from "./logSerialize";



export class NativeLogger extends NGXLoggerWriterService {
  constructor(
    private crossAppMessaging: CrossAppMessagingService,
  ) {
    super(1);
  }

  override writeMessage(metadata: INGXLoggerMetadata, config: INGXLoggerConfig): void {


    var msk: IMessage = {
      action: 'log',
      data: {
        message: typeof metadata.message === 'string' ? metadata.message : safeStringify(metadata.message),
        level: metadata.level,
        // stringify samo kad stvarno ima dodatnih argumenata (velika većina poziva nema);
        // safeStringify: Error → {name, message, stack}, ciklična struktura ne obara upis.
        additional: metadata.additional?.length
          ? safeStringify(metadata.additional)
          : '',
      }
    };
    this.crossAppMessaging?.sendRawMessage(msk)

    // Konzola: normalne poruke rutirane po nivou (greške kao console.error), samo van produkcije.
    if (!environment.production) {
      writeToConsole(metadata);
    }
  }
}
